import React from "react";
import { StampToDate, StampTo24hr, minutesToHrMin } from "../../../Utils/utils";
import { FaPlane, FaTag } from "react-icons/fa";

function LinkedFlightBooking({ flight, className = "" }) {
	if (!flight) return null;

	return (
		<div className={className}>
			<h6 className="flex gap-x-2 items-center mt-4 text-sm">
				<FaTag className="w-3" />
				Expense tagged to Flight
			</h6>
			<div className="overflow-hidden mt-4 min-w-min rounded-xl border shadow-sm bg-canvas">
				<div className="p-4">
					<div className="flex justify-between items-start">
						<div className="align-center">
							<img
								src={`https://cdn.travelwings.com/globalassets/images/${flight.airlineCode?.toUpperCase()}.jpg`}
								alt={flight.airlineCode}
								className="mr-2 w-6 h-6 rounded-full"
								onError={(e) => {
									e.target.src =
										"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%23ccc' d='M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z'/%3E%3C/svg%3E";
								}}
							/>
							<div className="text-xs whitespace-nowrap text-secondary">
								{flight.airlineCode}-{flight.flightNumber}
							</div>
						</div>
						<div className="text-xs font-bold">{StampToDate(flight.departureTime)}</div>
					</div>
					<div className="flex gap-x-4 mt-3">
						<div>
							<div className="font-bold whitespace-nowrap">{flight.departureCode}</div>
							<div className="text-xs text-secondary">{StampTo24hr(flight.departureTime)}</div>
						</div>
						<div className="flex-grow w-24 flex-center">
							<div className="w-full">
								<div className="align-center">
									<div className="w-2 h-2 rounded-full border border-dark" />
									<div className="flex-grow border-t border-dotted border-dark" />
									<FaPlane />
									<div className="flex-grow border-t border-dotted border-dark" />
									<div className="w-2 h-2 rounded-full border border-dark" />
								</div>
								<div className="mt-2 text-xs text-center whitespace-nowrap">{minutesToHrMin(flight.duration)}</div>
							</div>
						</div>
						<div>
							<div className="font-bold whitespace-nowrap">{flight.arrivalCode}</div>
							<div className="text-xs text-secondary">{StampTo24hr(flight.arrivalTime)}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default LinkedFlightBooking;
